import request from "@/utils/request";
export default (identifier) => request("quotes/" + identifier);
